import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      iconSrc: "/img/feature_icons/fast_ranges.png",
      altText: "Fast Rangeviewer Icon",
      title: "GTO Fast Rangeviewer",
      description: (
        <>
          The <strong>fastest rangeviewer</strong> designed with <strong>speed in mind</strong>. 
          Instantly access <strong>95% of common poker spots</strong>. All ranges stored 
          on-device for <strong>offline use</strong> with no delay.
        </>
      )
    },
    {
      iconSrc: "/img/feature_icons/advanced.png",
      altText: "Advanced Rangeviewer Icon",
      title: "Advanced Rangeviewer",
      description: (
        <>
          For <strong>complex multiway spots</strong>, <strong>5bet pots</strong>, 
          <strong>squeezes</strong> and uncommon scenarios. The perfect tool for 
          <strong>deeper study</strong> of rarer situations with multiple variables.
        </>
      )
    },
    {
      iconSrc: "/img/feature_icons/trainer.png",
      altText: "Preflop Trainer Icon",
      title: "Preflop Trainer",
      description: (
        <>
          The <strong>#1 preflop trainer</strong> with <strong>infinite hands</strong> to practice. 
          Get <strong>instant feedback</strong> with appropriate ranges and 
          <strong>EV loss calculations</strong> to perfect your strategy.
        </>
      )
    },
    {
      iconSrc: "/img/feature_icons/stats.png",
      altText: "Statistics Icon",
      title: "Statistics Page",
      description: (
        <>
          <strong>Track your progress</strong> with detailed performance analytics. 
          <strong>Identify strengths</strong> and pinpoint <strong>areas for improvement</strong> 
          to focus your poker study effectively.
        </>
      )
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <h2>Key Features</h2>
        <div className="feature-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">
                <img src={feature.iconSrc} alt={feature.altText} loading="lazy" />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 